import React__default from 'react';
import ItemPlaceHolder from "../assets/item-card-placeholder-0f7c213a.jpg";
import { getImgFromArr as getImgFromArr_1 } from './../external_lib/array-to-image/dist/index.js';
import { decodeBlurHash } from './../external_lib/fast-blurhash/index.js';
import './../external_lib/react-lazy-load-image-component/build/index.js';
import { exports as buildExports } from '../_virtual/index.js';

function LazyImage(_a) {
    var src = _a.src, alt = _a.alt, width = _a.width, height = _a.height, blur_hash = _a.blur_hash, classes = _a.classes, onClick = _a.onClick; _a.imageComponent; _a.priority;
    var handleOnClick = function () {
        onClick && onClick();
    };
    var handleOnError = function (event) {
        event.currentTarget.src = ItemPlaceHolder;
    };
    var toNumber = function (value) {
        if (typeof value === 'number') {
            return value;
        }
        return parseInt(value, 10);
    };
    if (blur_hash && blur_hash.length > 15 && height && width) {
        getImgFromArr_1(decodeBlurHash(blur_hash, toNumber(width), toNumber(height)), width, height);
    }
    var formatImageSrc = function (src) {
        return src
            ? width && !(src.split('.').pop() === 'gif')
                ? "".concat(src, "?width=").concat(width)
                : src
            : typeof ItemPlaceHolder === 'string'
                ? ItemPlaceHolder
                : ItemPlaceHolder.src;
    };
    // if (!imageComponent) {
    return (React__default.createElement(buildExports.LazyLoadImage, { onClick: handleOnClick, className: classes, alt: alt, src: formatImageSrc(src), width: width || 'auto', height: height || 'auto', placeholderSrc: typeof ItemPlaceHolder === 'string'
            ? ItemPlaceHolder
            : ItemPlaceHolder.src, placeholder: typeof ItemPlaceHolder === 'string'
            ? ItemPlaceHolder
            : ItemPlaceHolder.src, delayTime: 4000, useIntersectionObserver: true, delayMethod: 'debounce', threshold: 10, visibleByDefault: true, onError: handleOnError }));
    // }
    // return imageComponent({
    //   src:
    //     src ||
    //     (typeof ItemPlaceHolder === 'string'
    //       ? ItemPlaceHolder
    //       : ItemPlaceHolder.src),
    //   alt,
    //   width: width || ItemPlaceHolder.width,
    //   height: height || ItemPlaceHolder.height,
    //   className: classes,
    //   priority: priority || false,
    //   placeholder: placeHolderImage ? 'blur' : 'empty',
    //   blurDataURL: placeHolderImage || ItemPlaceHolder.blurDataURL
    // });
}

export { LazyImage as default };
//# sourceMappingURL=LazyImage.js.map
